import React from "react";
import TrustedFormLoader from "./TrustedFormLoader";
import FbPixelLoader from "./FbPixelLoader";
import FunnelFooter from "./FunnelFooter";

const STEPS = [
  { num: 1, label: "Start" },
  { num: 2, label: "Family" },
  { num: 3, label: "Questions" },
  { num: 4, label: "Contact" },
  { num: 5, label: "Review" },
  { num: 6, label: "Complete" }
];

function BrandLogo() {
  return (
    <svg
      className="fv2-logo"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M21 2L5 9v12c0 9.4 6.8 18.2 16 20 9.2-1.8 16-10.6 16-20V9L21 2z" fill="#0d2954" />
      <circle cx="21" cy="15" r="3.5" fill="white" />
      <circle cx="14.5" cy="18.5" r="2.5" fill="white" opacity="0.7" />
      <circle cx="27.5" cy="18.5" r="2.5" fill="white" opacity="0.7" />
      <path d="M21 20c-4 0-7 2.5-7 5.5h14c0-3-3-5.5-7-5.5z" fill="white" />
      <path d="M14.5 22c-2.5 0-4.5 1.5-4.5 3.5h9c0-2-2-3.5-4.5-3.5z" fill="white" opacity="0.6" />
      <path d="M27.5 22c-2.5 0-4.5 1.5-4.5 3.5h9c0-2-2-3.5-4.5-3.5z" fill="white" opacity="0.6" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92v2z" />
    </svg>
  );
}

export default function FunnelLayout({
  currentStep,
  showProgress = true,
  wide = false,
  complete = false,
  children
}) {
  return (
    <div className="fv2-shell">
      <TrustedFormLoader />
      <FbPixelLoader />
      <header className="fv2-header">
        <div className="fv2-header-inner">
          <div className="fv2-brand">
            <BrandLogo />
            <div className="fv2-brand-text">
              <strong>Family Health</strong>
              <span>Plans</span>
            </div>
          </div>

          <a className="fv2-call" href="tel:+18337212356">
            <span className="fv2-call-icon">
              <PhoneIcon />
            </span>
            <div className="fv2-call-text">
              <small>Speak with a licensed agent</small>
              <strong>(833) 721-2356</strong>
            </div>
          </a>
        </div>
      </header>

      {showProgress && (
        <nav className="fv2-progress" aria-label="Funnel progress">
          <div className="fv2-progress-inner">
            {STEPS.map((step) => {
              const status = complete
                ? "done"
                : step.num < currentStep
                ? "done"
                : step.num === currentStep
                ? "current"
                : "upcoming";

              return (
                <div key={step.num} className={`fv2-progress-step fv2-${status}`}>
                  <div className="fv2-progress-dot">
                    {status === "done" ? "✓" : step.num}
                  </div>
                  <span className="fv2-progress-label">{step.label}</span>
                </div>
              );
            })}
          </div>
        </nav>
      )}

      <main className={wide ? "fv2-main fv2-main-wide" : "fv2-main"}>
        {children}
      </main>

      <FunnelFooter />
    </div>
  );
}
